import * as moment from 'moment';
import momentTimezone from 'moment-timezone';

const getHeaders = (isMultipart, bodyObj = {}) => {
  let headers = {};
  if (!isMultipart) {
    headers = { ...headers, 'Content-Type': 'application/json' };
  } else {
    headers = {
      ...headers,
      'Content-Type': `multipart/form-data; boundary=${bodyObj._boundary}`,
    };
  }
  return headers;
};

const dateFormat = (dateInput) => {
  return moment(dateInput).format('DD/MM/YYYY HH:mm:ss');
};

const dateOnlyFormat = (dateInput) => {
  return moment(dateInput).format('DD/MM/YYYY');
};

const isObjectEmpty = (ob) => {
  if (typeof ob === 'object' && ob !== null)
    return Object.keys(ob).length === 0;
  return true;
};

export const isStringEmpty = (string) => {
  let empty = true;
  if (string === undefined || string === null) return empty;
  if (string.length > 0) return false;
  return empty;
};

export const constructURL = (baseURL, params) => {
  let finalURL = baseURL,
    index = 0;
  for (const key in params) {
    let el = params[key];
    if (el !== undefined || el !== null) {
      if (index === 0) finalURL = `${finalURL}?${key}=${el}`;
      else finalURL = `${finalURL}&${key}=${el}`;
      index++;
    }
  }
  return finalURL;
};

export const getDeviceAndWidth = () => {
  const width = window.innerWidth;
  const height = window.innerHeight;
  let device = 'desktop';
  if (width > 768) {
    return { device, width, height };
  } else if (width > 599 && width <= 768) {
    return { device: 'tablet', width, height };
  } else {
    return { device: 'phone', width, height };
  }
};

export const isPastToday = (tDate) => {
  const TODAY = moment();
  const targetDate = moment(tDate);
  const diff = targetDate.diff(TODAY, 'days');
  if (diff < 0) return true;
  return false;
};

export const daysDiff = (d1, d2) => {
  const laterDate = moment(d2);
  const targetDate = moment(d1);
  return targetDate.diff(laterDate, 'days');
};
export const getBrowserTimeZone = () => {
  const timeZone = momentTimezone.tz.guess();
  return momentTimezone.tz(timeZone).format('z');
};

export const validateEmail = (email, regex) => {
  // const re = /^\w+([\.\+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/;
  // const re = /^[\p{L}\p{M}0-9._%+-]+@[\p{L}\p{M}0-9.-]+\.[A-Za-z]{2,6}$/u;
  //covers all : /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}$/u

  const re = /^[A-Za-z0-9._+-]+@[A-Za-z0-9._-]+\.[A-Za-z]{2,6}$/;
  if (regex != null) {
      try {
        regex = new RegExp(regex, 'u');
        return regex.test(email);
      } catch (error) {
        return re.test(email);
      }
  }
  return re.test(email);
};

export const validateName = (nameVal) => {
  const re = /^[\p{L}\p{M}0-9'’,._\- ]+$/u;
  return re.test(nameVal);
};

export const getUniqueArrayByID = (arr) => {
  const uniqArr = arr.reduce(function (previous, current) { //NOSONAR
    const object = previous.filter((obj) => obj.id === current.id);
    if (object.length == 0) {
      previous.push(current);
    }
    return previous;
  }, []);
  return uniqArr;
};

export const getUniqueArrayByTimeStamp = (arr) => {
  const uniqArr = arr.reduce(function (previous, current) { //NOSONAR
    const object = previous.filter((obj) => obj.timeStamp === current.timeStamp);
    if (object.length == 0) {
      previous.push(current);
    }
    return previous;
  }, []);
  return uniqArr;
};
export const LanguageForCode = (code) => {
  let Language = ''
  switch (code){
    case 'en':
    Language = 'English';
    break;
    case 'fr':
      Language = 'French';
    break;
    case 'de':
      Language = 'German';
    break;
    case 'it':
      Language = 'Italian';
    break;
    case 'es':
      Language = 'Spanish';
    break;
    case 'pt':
      Language = 'Portuguese (Brazil)';
    break;
    case 'in':
      Language = 'Indonesian';
    break;
    case 'ja':
      Language = 'Japanese';
    break;
    default:
    Language = 'English';
    break;
  }
  return Language;
}

export const filterActiveStatus = (userSubscriptionInfoArray) => {
  let collaborationList1 = [];
  let adhocList1 = [];
  userSubscriptionInfoArray?.map((i) => {
    collaborationList1 = collaborationList1.concat(
      i.subscriptionStatus.collabSubscriptionStatus
    );
    adhocList1 = adhocList1.concat(
      i.subscriptionStatus.adhocSubscriptionStatus
    );
  });
  let formattedActiveCollabList =
    collaborationList1 && collaborationList1.length > 0
      ? collaborationList1.filter((i) => i === 'ACTIVE')
      : [];
  let formattedActiveAdhocList =
    adhocList1 && adhocList1.length > 0
      ? adhocList1.filter((i) => i === 'ACTIVE')
      : [];

  return { formattedActiveCollabList, formattedActiveAdhocList };
};

//a=isEducationSubscriptionAvailable, b=isCollaborationSubscriptionAvailable, c=EnterpriseRolesList, itemsList=Array of side menu options
export const setMenuItems = (itemsList, b, c, adhoc, activeConfigList) => {
  let menuItems = [];
  let { isCollaborationActive, isAdhocActive } = activeConfigList;
  itemsList.forEach((item) => {
    if (isAdhocActive) {
      if (c.includes('ADMIN') && item.key === 'People') {
        menuItems = menuItems.concat(item);
      }
      if (!isCollaborationActive && item.key === 'Info') {
        menuItems = menuItems.concat(item);
      }
    }
    else {
      if (b && c.includes('ADMIN') && item.key === 'People') {
        menuItems = menuItems.concat(item);
      }
    }
  });

  return menuItems;
};

export const changeUnauthlang=(i18n,lang)=>{
  switch (lang) {
    case "English":
      i18n.changeLanguage('en');
      localStorage.setItem('unAuthLang', 'en');
      break;
    case "French":
      i18n.changeLanguage('fr');
      localStorage.setItem('unAuthLang', 'fr');
      break;
    case "German":
      i18n.changeLanguage('de');
      localStorage.setItem('unAuthLang', 'de');
      break;
    case "Spanish":
      i18n.changeLanguage('es');
      localStorage.setItem('unAuthLang', 'es');
      break;
    case "Italian":
      i18n.changeLanguage('it');
      localStorage.setItem('unAuthLang', 'it');
      break;
    case "Portuguese (Brazil)":
      i18n.changeLanguage('pt');
      localStorage.setItem('unAuthLang', 'pt');
      break;
    case "Indonesian":
      i18n.changeLanguage('id');
      localStorage.setItem('unAuthLang', 'id');
      break;
    case "Japanese":
      i18n.changeLanguage('ja');
      localStorage.setItem('unAuthLang', 'ja');
      break;
    default:
      i18n.changeLanguage('en');
      break;
  }
}

export { getHeaders, dateFormat, isObjectEmpty, dateOnlyFormat };
